import { render } from "./ourphysician.vue?vue&type=template&id=9fe791c2"
import script from "./ourphysician.vue?vue&type=script&lang=js"
export * from "./ourphysician.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__